export default __webpack_public_path__ + "static/media/Untitled-3.afed863c.png";